import fetch from 'isomorphic-unfetch'

const toJson = r => r.json()

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
}
const MAPS_API_URL = 'https://map-api.viadelivery.pro/'

export const postData = async (
  url: string,
  body: Record<string, unknown>,
  headers = {},
): Promise<any> =>
  await fetch(url, {
    method: 'post',
    headers: {
      ...DEFAULT_HEADERS,
      ...headers,
    },
    body: JSON.stringify(body),
  }).then(toJson)

export const getData = async (url: string, headers = {}): Promise<any> => {
  try {
    return await fetch(url, {
      method: 'get',
      headers: {
        ...DEFAULT_HEADERS,
        ...headers,
      },
    }).then(toJson)
  } catch (e) {
    console.error(`Error fetching data: ${url}`, e)
    throw e
  }
}

export const extendWithAddress = async data => {
  try {
    const pointData = await getData(
      `${MAPS_API_URL}point-info/?point_id=${
        data.in_point_uuid || data.in_point
      }`,
    )
    return {
      ...data,
      point_description: pointData[0].description,
      point_address: pointData[0].full_address,
    }
  } catch {
    return {
      ...data,
      point_description: data.in_point,
      point_address: data.in_point_address,
    }
  }
}

export const escQuery = (str: string, default_str = ''): string =>
  str ? decodeURI(str).replace(/['"<>%#&]/g, '') : default_str
